"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchApi_1 = __importDefault(require("../../rest/fetchApi"));
var contentServiceUrl = process.env.CB_CONTENT_SERVICE_SERVER_URL;
var CourseBuilderAPIS = {
    getImageSignedUrl: function (token, fileName) {
        return fetchApi_1.default.get({
            mockFunc: function () { return ({}); },
            url: "".concat(contentServiceUrl, "/image-signed-url/").concat(fileName),
            token: token,
        });
    },
    uploadImage: function (signedUrl, image, type) {
        return fetch(signedUrl, {
            method: 'PUT',
            body: new Blob([image], { type: type }),
        });
    },
};
exports.default = CourseBuilderAPIS;
